import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./HealthBenefits.css";

const cards = [
  {
    icon: <img src="/icons/robot.webp" alt="Efficiency" />,
    title: "CASE MANAGEMENT AND AUTOMATION",
    desc: "Legaltech software automates repetitive tasks, streamlines case workflows, and facilitates collaboration, allowing lawyers to focus on high-value strategic work."
  },
  {
    icon: <img src="/icons/computer.webp" alt="Sustainability" />,
    title: "E-DISCOVERY & LEGAL RESEARCH",
    desc: "Advanced tools enable efficient document review, legal research, and evidence management, reducing time and costs associated with these critical processes."
  },
  
  {
    icon: <img src="/icons/human.webp" alt="Engagement" />,
    title: "CLIENT COMMUNICATION AND COLLABORATION",
    desc: "Secure online portals and collaboration platforms foster seamless communication and document sharing with clients, enhancing transparency and client satisfaction."
  }
];

export default function GreenBenefits({ imageSrc }) {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className="green-benefits-section" id="benefits">
      <div className="green-benefits-top">
        <div className="green-benefits-text" data-aos="fade-right">
          <div className="green-benefits-title">
            DIGITAL ACCELERATION<br />
            <span className="green-benefits-title-blue">IN LEGAL TECHNOLOGY</span>
          </div>
          <div className="green-benefits-desc">
            Whether you are focused on contract management, legal research, or case management, our software solutions provide comprehensive tools to meet your specific needs. Unlock the potential of technology and embrace digital transformation in the Legaltech industry.
          </div>
        </div>
        <div className="green-benefits-image" data-aos="fade-left">
          <img src={imageSrc} alt="Digital Acceleration" />
        </div>
      </div>
      <div className="green-benefits-cards">
        {cards.map((card, i) => (
          <div
            className="green-benefits-card"
            key={i}
            data-aos="fade-up"
            data-aos-delay={100 + i * 100}
          >
            <div className="green-benefits-card-icon">{card.icon}</div>
            <div className="green-benefits-card-title">{card.title}</div>
            <div className="green-benefits-card-desc">{card.desc}</div>
          </div>
        ))}
      </div>
      <div className="green-benefits-btn-row" data-aos="fade-up" data-aos-delay="500">
        <button className="green-benefits-btn">
          MORE ABOUT DIGITAL ACCELERATION
        </button>
      </div>
    </section>
  );
}